import { gql } from '@apollo/client'

const UPDATE_STATUS_CAMPAIGN = gql`
  mutation ($campaignId: ID!, $statusChange: CampaignStatusInput!) {
    updateStatusCampaign(campaignId: $campaignId, statusChange: $statusChange) {
      error {
        code
        message
      }
    }
  }
`

export default UPDATE_STATUS_CAMPAIGN
